import toast from "react-hot-toast";
import { supabase } from ".";

export const getFacturasComision2 = async ({ edificio, fechas, pais }) => {
  try {
    const data = await supabase.select("sales", {
      filters: {
        pais: pais, // Direct string value, becomes pais=eq.Perú
        facturafecha: {
          gte: fechas[0],
          lte: fechas[1],
        },
        edificiosparticipantes: { like: String(edificio) },
        eliminada: !true,
      },
    });

    const filteredData = data.filter((sale) => {
      const edificiosList = sale.edificiosparticipantes ? sale.edificiosparticipantes.split(",") : [];
      return edificiosList.includes(String(edificio));
    });

    if (filteredData.length === 0) {
      toast.error("No hay facturas asociadas al edificio en las fechas seleccionadas");
      throw new Error("No data found");
    }

    return filteredData;
  } catch {
    return [];
  }
};
